module.exports = __webpack_public_path__ + "static/mastodon-2403abcc00221901bf1b25e60854ee18.jpg";